module.exports = __webpack_public_path__ + "static/media/Immobilier-Execution-Vaud.44415d06.jpg";